__webpack_require__.p = "/mi-assets/mi-static/mi-account-renderer/web-rel-26.9.1-090120261700/_next/";